// Sovereign Reading Speed & Duration Estimator
// Calculates estimated reading duration based on article heuristics and note content

export function estimateReadingTime(item) {
  if (!item) return null;

  const title = item.title || '';
  const note = item.notes || item.note || item.description || '';
  const url = item.url || '';

  // Combine available text content
  const fullText = `${title} ${note}`.trim();
  const wordCount = fullText ? fullText.split(/\s+/).length : 0;

  // Domain-based duration heuristics if minimal notes exist
  let estimatedMinutes = Math.max(1, Math.ceil(wordCount / 180));

  if (wordCount < 30) {
    // Check if domain is typically long-form reading
    if (/medium\.com|substack\.com|dev\.to|arxiv\.org|wikipedia\.org|blog\./i.test(url)) {
      estimatedMinutes = 5;
    } else if (/docs\.|developer\.|github\.com/i.test(url)) {
      estimatedMinutes = 4;
    } else {
      estimatedMinutes = 2;
    }
  }

  if (estimatedMinutes >= 10) {
    return {
      minutes: estimatedMinutes,
      label: `${estimatedMinutes}m deep dive`,
      isDeepDive: true,
    };
  }

  return {
    minutes: estimatedMinutes,
    label: `${estimatedMinutes} min read`,
    isDeepDive: false,
  };
}
